














import {
  Vue,
  Component
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import LoadingSpinner from "@/shared/components/ui/LoadingSpinner.vue";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    Button,
    LoadingSpinner
  }
})
export default class AdminFraudPreventionReport extends Vue {
  userStore = useUserStore();

  downloadCsv () {
    this.userStore.downloadFraudPreventionReport();
  }
}
